import { useState, useEffect } from 'react';
import axios from 'axios';

import * as Icons from '../../../images/icons/icons_component';

function TrnNote_popup() {

    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    }
    const [data, setData] = useState([]);
    const [checkItems, setCheckItems] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [editableData, setEditableData] = useState([]);
    const [searchParams, setSearchParams] = useState({
        searchEmog: '',
        searchYear: '',
        searchMonth: '',
        searchTrnNm: '',
    });
    const dataColumn = ['EDU_GUBUN', 'EDU_CONTENT', 'TYPE_1', 'TYPE_2', 'EXC_YN'];
    const dataHead = ['교육구분', '교육내용', '필수사항', '권고사항', '수행여부'];
    const sendData = JSON.parse(localStorage.getItem('trnNoteData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/trnlst/trnNoteDetailSearch.do', {
                params: searchParams
            });
            setData(response.data);
            setCheckItems([]);
            console.log(response.data);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(prev => ({
            ...prev,
            [name]: value,
        }));
    };
    useEffect(() => {
        if (!searchParams.searchEmog) return;
        const fetchAndSetTrnList = async () => {
            try {
                const response = await axios.get('/trmsapi/trnlst/searchTrnNm.do', {
                    params: { searchEmog: searchParams.searchEmog }
                });

                const list = response.data || [];
                setNameList(list);

                const firstTrn = list.length > 0 ? list[0].DETAIL_SN : '';
                setSearchParams(prev => ({
                    ...prev,
                    searchTrnNm: firstTrn
                }));
                console.log(firstTrn);
            } catch (error) {
                console.error('병원 목록 로딩 중 오류 발생:', error);
            }
        };
        fetchAndSetTrnList();
    }, [searchParams.searchEmog]);
    useEffect(() => {
        if (!searchParams.searchTrnNm) return;
        popupData();
    }, [searchParams.searchYear, searchParams.searchMonth, searchParams.searchTrnNm]);
    useEffect(() => {
        setSearchParams((prev) => ({
            ...prev,
            searchEmog: sendData.searchEmog || sendData.searchHosp,
            searchYear: sendData.searchYear || sendData.IEM_ID.toString().slice(0, 4),
            searchMonth: sendData.searchMonth || sendData.IEM_ID.toString().slice(4, 6),
            searchTrnNm: sendData.searchTrnNm || sendData.DETAIL_SN,
        }));
        popupData();
    }, []);
    const save = async () => {
        try {
            console.log(data);
            console.log(checkItems);
            const params = new URLSearchParams();
            params.append('jsonArr', JSON.stringify(data));
            params.append('deljsonArr', JSON.stringify(checkItems));
            params.append('userId', localStorage.getItem('id'));

            const response = await axios.post('/trmsapi/trnlst/saveTrnNoteEdu.do', params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            alert(response.data.resultMessage || '저장 완료');
        } catch (error) {
            console.error('eduList 저장 중 오류 발생:', error);
        }
    };

    const handleAllCheck = (checked) => {
        setCheckItems(checked ? [...data] : []);
    };

    const handleSingleCheck = (checked, item) => {
        setCheckItems(prev =>
            checked ? [...prev, item] : prev.filter(i => i.NOTE_SEQ !== item.NOTE_SEQ)
        );
    };

    const handleCellChange = (rowIndex, col, value) => {
        setData((prevData) => {
            const updatedData = [...prevData];
            const row = { ...updatedData[rowIndex] };
            const originalValue = row[col];

            if (originalValue === value) return prevData;

            row[col] = value;
            if (col === 'TYPE_1' && value === 'Y') {
                row['TYPE_2'] = 'N';
            } else if (col === 'TYPE_1' && value === 'N') {
                row['TYPE_2'] = 'Y';
            } else if (col === 'TYPE_2' && value === 'Y') {
                row['TYPE_1'] = 'N';
            }
            else if (col === 'TYPE_2' && value === 'N') {
                row['TYPE_1'] = 'Y';
            }

            updatedData[rowIndex] = row;
            return updatedData;
        });
    };
    const handleAddRow = () => {
        const newRow = {
            NOTE_SEQ: Date.now(),
            EDU_GUBUN: '교육구분',
            EDU_CONTENT: '교육내용',
            IEM_ID: searchParams.searchYear + searchParams.searchMonth,
            DETAIL_SN: searchParams.searchTrnNm,
            EMOGCODE: searchParams.searchEmog,
        };
        setData((prevData) => [newRow, ...prevData]);
    };
    const handleDeleteRows = () => {
        setData(prevData => prevData.filter(item =>
            !checkItems.some(checkedItem => checkedItem.NOTE_SEQ === item.NOTE_SEQ)
        ));
    };
    const computeRowSpans = (dataList, mergeConfig = [], allColumns = []) => {
        const rowSpans = dataList.map(() => ({}));

        mergeConfig.forEach(({ key: colKey, row, nullable }) => {
            let prevValue = null;
            let startIndex = 0;
            let mergeCount = 1;

            for (let i = 0; i < dataList.length; i++) {
                const currentValue = dataList[i][colKey];
                const isMergeable = nullable
                    ? currentValue === prevValue
                    : currentValue === prevValue && currentValue !== '' && currentValue !== null;

                if (isMergeable) {
                    if (row == null || mergeCount < row) {
                        rowSpans[startIndex][colKey] += 1;
                        rowSpans[i][colKey] = 0;
                        mergeCount += 1;
                    } else {
                        rowSpans[i][colKey] = 1;
                        startIndex = i;
                        mergeCount = 1;
                    }
                } else {
                    rowSpans[i][colKey] = 1;
                    startIndex = i;
                    mergeCount = 1;
                    prevValue = currentValue;
                }
            }
        });

        dataList.forEach((_, i) => {
            allColumns.forEach(colKey => {
                if (!(colKey in rowSpans[i])) {
                    rowSpans[i][colKey] = 1;
                }
            });
        });
        return rowSpans;
    };

    const rowSpans = computeRowSpans(data, [{ key: 'EDU_GUBUN', row: null }], dataColumn);

    const modifyY = currentYear.toString() + currentMonth.toString() === searchParams.searchYear.toString() + searchParams.searchMonth.toString();
    
    return (
        <div className='popup_container bg_tr_bg'>
            <h4>수련노트</h4>
            <div className='com-search tr_pop_th_bg'>
                <hr className='border-t-2 tr_border_primary' />
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>조회기간</th>
                            <td>
                                <select id="searchYear"
                                    name="searchYear"
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year}년
                                            </option>
                                        );
                                    })}
                                </select>
                                &nbsp;
                                <select id="searchMonth"
                                    name="searchMonth"
                                    value={searchParams.searchMonth}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = (i + 1).toString().padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month}월
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                            <th>의료기관명</th>
                            <td>
                                <select
                                    name='searchEmog'
                                    className='w-full'
                                    value={searchParams.searchEmog}
                                    onChange={handleInputChange}
                                >
                                    <option value="A1100014">고려대학교의과대학부속구로병원</option>
                                    <option value="A1400001">의료법인 길의료재단 길병원</option>
                                    <option value="A2100040">가톨릭대학교의정부성모병원</option>
                                    <option value="A2200001">연세대학교원주세브란스기독병원</option>
                                    <option value="A2900001">제주한라병원</option>
                                    <option value="A2100002">아주대학교병원</option>
                                </select>
                            </td>
                            <th>전문의명</th>
                            <td>
                                <select
                                    name='searchTrnNm'
                                    className='w-full'
                                    value={searchParams.searchTrnNm}
                                    onChange={handleInputChange}
                                >
                                    {nameList.map(name => (
                                        <option key={name.DETAIL_SN} value={name.DETAIL_SN}>
                                            {name.NM}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='px-2'>
                <p className='co_light_red text-xs'>※ 삭제순서</p>
                <p className='co_light_red text-xs'>1.원하시는 항목을 체크 후 행삭제 클릭</p>
                <p className='co_light_red text-xs'>2.저장버튼 클릭(저장 버튼 클릭 전까지는 삭제되지 않습니다, 잘못 삭제한 경우 재조회 후 입력 권장)</p>
            </div>
            <div className='search_btn_wrapper p-0'>
                <span className='total_items'>전체&nbsp;<strong className='tr_primary'>{data.length}</strong>건</span>
                <div className='btn_container'>
                    <button onClick={popupData} title='조회' className='search_btn bg_tr_primary'><Icons.Search16w />조회</button>
                    {modifyY ?
                        <>
                            <button onClick={handleAddRow} title='행추가' className='search_btn bg_co_black'><Icons.AddCircle16w/>행추가</button>
                            <button onClick={handleDeleteRows} title='행삭제' className='search_btn bg_co_black'><Icons.DeleteCircle16w/>행삭제</button>
                            <button onClick={save} title='저장' className='search_btn bg_co_black'><Icons.Save16w/>저장</button>
                        </> : ''
                    }
                </div>
            </div>
            <div>
                <div className='data_grid_container'>
                    <hr className={`border-t-2 mr-1-1 tr_border_soft`} />
                    <div className="data_list_table" style={{ maxHeight: '38rem' }}>
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            className='m-0'
                                            disabled={modifyY ? false : true}
                                            checked={data.length > 0 && checkItems.length === data.length}
                                            onChange={(e) => handleAllCheck(e.target.checked)}
                                        />
                                    </th>
                                    {dataHead.map((h, i) => (
                                        <th key={i}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, rowIndex) => {
                                    const rowSeq = item.NOTE_SEQ;
                                    const editedRow = editableData[rowSeq] || {};
                                    const isChecked = checkItems.some(i => i.NOTE_SEQ === rowSeq);

                                    return (
                                        <tr key={rowSeq} className={item.isNew ? 'bg-yellow-100' : ''}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    className='m-0'
                                                    disabled={modifyY ? false : true}
                                                    checked={isChecked}
                                                    onChange={e => handleSingleCheck(e.target.checked, item)}
                                                />
                                            </td>

                                            {dataColumn.map((col, colIndex) => {
                                                const span = rowSpans?.[rowIndex]?.[col];
                                                if (span === 0) return null;

                                                const value = editedRow[col] !== undefined ? editedRow[col] : item[col];

                                                if (['TYPE_1', 'TYPE_2', 'EXC_YN'].includes(col)) {
                                                    return (
                                                        <td key={colIndex} rowSpan={span} style={{ textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                className='m-0'
                                                                disabled={modifyY ? false : true}
                                                                checked={value === 'Y' || value === true}
                                                                onChange={e =>
                                                                    handleCellChange(rowIndex, col, e.target.checked ? 'Y' : 'N')
                                                                }
                                                            />
                                                        </td>
                                                    );
                                                }
                                                return (
                                                    <td key={colIndex} rowSpan={span}>
                                                        <input
                                                            type="text"
                                                            className={modifyY ? 'input_style' : 'outline-none'}
                                                            value={value || ''}
                                                            onChange={e => handleCellChange(rowIndex, col, e.target.value)}
                                                        />
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <hr className='mr-1-1 co_border_gray'/>
                </div>
            </div>
        </div >
    );
}
export default TrnNote_popup;